
import _isString from 'lodash/isString'
import { validate as uuidValidate } from 'uuid'

import {
  ROUTE_NAME_RESERVATIONS,
  ROUTE_PARAM_RESERVATION_ID,
  ROUTE_URL_NOT_FOUND,
} from '@/router'

export default {
  name: 'ExistingReservation',
  async beforeCreate() {
    const reservationId = this.$route.params[ROUTE_PARAM_RESERVATION_ID]

    if (!_isString(reservationId) || !uuidValidate(reservationId)) {
      return this.$router.replace({ name: ROUTE_NAME_RESERVATIONS })
    }

    if (!this.$store.getters['api/reservationValid']) {
      try {
        await this.$store.dispatch(
          'api/getReservation',
          this.$route.params[ROUTE_PARAM_RESERVATION_ID]
        )
      } catch (e) {
        this.$router.push({ name: ROUTE_URL_NOT_FOUND })
      }
    }
  },
}
